import * as React from 'react';
import { IconName } from '~/common/enums/enums';
import { AppLocalizationKey, TechtimeTimelineItem } from '~/common/types/types';
import { FormattedMessage, Icon } from '~/components/common/common';
import { LectureItem } from '../lecture-item/lecture-item';
import * as styles from './lectures-list.module.scss';

type Props = {
  items: TechtimeTimelineItem[];
  notice: AppLocalizationKey;
};

const LecturesList: React.FC<Props> = ({ items, notice }) => (
  <div className={styles.listWrapper}>
    <ul className={styles.list}>
      {items.map((item, idx) => (
        <LectureItem item={item} key={item.title} displayNumber={idx + 1} />
      ))}
    </ul>
    <div className={styles.notice}>
      <Icon iconName={IconName.NOTICE} className={styles.noticeIcon} />
      <FormattedMessage message={notice} className={styles.noticeText} />
    </div>
  </div>
);

export { LecturesList };
